export const noMobileDisplayStyle = {
  display: ["none", "none", "none", "block"],
};
export const onlyDisplayDesktopUpwards = { display: ["none", "block"] };
export const marginBottomForSmallDevices = [
  "20px !important",
  "20px !important",
  "20px !important",
  "0 !important",
];
export const smallDeviceWidthSize = [
  "100% !important",
  "40px !important",
  "40px !important",
  "230px !important",
];
export const displayForSmallDevice = ["none", "none", "none", "block"];
export const flexDisplayForSmallDevice = ["none", "none", "none", "flex"];

export const marginLeftForSmallDevice = [
  "40px !important",
  "70px !important",
  "70px !important",
  "230px !important",
];

export const navMarginLeftForSmallDevice = ["-40px", "-40px", "-40px", "-10px"];

export const storiesSubstractWidthFromSidebar = [
  window.innerWidth - 40,
  window.innerWidth - 40,
  window.innerWidth - 40,
  window.innerWidth - 350,
];
export const sidebarPaddingLeftForSmallDevice = ["0px", "0px", "0px", "5px"];

export const BASE_COLOR = "#4461F2";
